<template>
  <span class="availability-indicator">
    <span
      v-if="isStocked"
      class="availability-indicator__available"
    >
      <span
        class="availability-indicator__trafficlight availability-indicator__trafficlight__available"
      />
      {{ $dict.get('dealer-Locator.Availability-Indicator.Available') }}
    </span>
    <span
      v-else
      class="availability-indicator__likelyavailable"
    >
      <span
        class="availability-indicator__trafficlight availability-indicator__trafficlight__likelyavailable"
      />
      {{ $dict.get('dealer-Locator.Availability-Indicator.Likely-Available') }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'AvailabilityIndicator',
  props: {
    isStocked: Boolean,
  },
};
</script>

<style scoped lang="scss">
@import './availability-indicator';
</style>
